import { ReactElement } from "react";
import { isSafari } from "react-device-detect";
import { Alert } from "./Alert";

export const SafariPrintAlert = (): ReactElement | null => {
  return isSafari ? (
    <Alert
      type={"error"}
      message={
        "The print function in Safari is buggy. If you need to use this function, we recommend you use an alternative browser, like Google Chrome."
      }
      className={"print:hidden"}
    />
  ) : null;
};
